module.exports = __webpack_public_path__ + "img/DasKleid.108552df.svg";